import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    // initial check
    this.toggleButton()
    // scroll listener
    this._onScroll = () => this.toggleButton()
    window.addEventListener("scroll", this._onScroll)
  }

  disconnect() {
    if (this._onScroll) window.removeEventListener("scroll", this._onScroll)
  }

  scrollToTop() {
    window.scrollTo({ top: 0, behavior: "smooth" })
  }

  toggleButton() {
    // add 'd-none' if scrolled less than 20px
    this.element.classList.toggle("d-none", window.scrollY < 20)
  }
}
